import { Button, Typography, Select, Dropdown, Tooltip } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import "./ReviewHeader.css";
import { saveAs } from "file-saver";
import { json2csv } from "json-2-csv";

import { useAlertStore } from "../../../../store/alert-store";
import { CustomButton } from "../../../../components/widgets/custom-button/CustomButton.jsx";

function ReviewHeader({
  title,
  classList,
  fetchNext,
  currentReview,
  setCurrentClass,
  currentClass,
  returnToQueue,
  getQueueDetals,
  finishReview,
  sessionDetails,
  type,
  getFinalizedList,
  setAutoApprove,
  autoApprove,
  fetchNextApi,
  finishReviewApi,
}) {
  const { setAlertDetails } = useAlertStore();
  const items = [
    {
      key: "json",
      label: "Download as json",
    },
    {
      key: "csv",
      label: "Download as csv",
    },
  ];
  // In progress feature
  // const manageItems = [
  //   {
  //     key: "rules",
  //     label: "Rules",
  //   },
  //   {
  //     key: "auto_approve",
  //     label: "Auto approve",
  //   },
  // ];
  const copyClassId = (text) => {
    navigator.clipboard
      .writeText(currentClass)
      .then(() => {
        setAlertDetails({
          type: "success",
          content: "Class ID copied to clipboard",
        });
      })
      .catch((error) => {
        setAlertDetails({
          type: "error",
          content: "Copy failed",
        });
      });
  };
  const handleDownloadJson = (data) => {
    const blob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json",
    });
    saveAs(blob, `${title}.json`);
  };
  const handleDownloadCSV = (data) => {
    const csv = json2csv(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${title}.csv`);
  };
  const downloadFile = (e) => {
    const type = e.key;
    const data = currentReview.output;
    if (type === "json") {
      handleDownloadJson(data);
    }
    if (type === "csv") {
      handleDownloadCSV(data);
    }
  };
  // In progress feature
  // const manageClick = (e) => {
  //   const type = e.key;
  //   if (type === "rules") {
  //     setAutoApprove(true);
  //   }
  //   if (type === "auto_approve") {
  //     setAutoApprove(true);
  //   }
  // };
  return (
    <div className="custom-tools-header-layout review-header">
      <div>
        <Select
          className="review-header-buttons review-select"
          options={classList.map((workflow) => ({
            label: workflow?.workflow_name,
            value: workflow?.workflow_id,
          }))}
          placeholder="Select Document Class"
          onChange={(value) => {
            setCurrentClass(value);
          }}
        />
        {(type === "simple_review" || type === "simple_approve") && (
          <Button
            onClick={fetchNextApi}
            className="review-header-buttons"
            disabled={!currentClass}
          >
            Fetch Next
          </Button>
        )}
        {type === "approve" && (
          <>
            <Button
              onClick={fetchNext}
              className="review-header-buttons"
              disabled={!currentClass}
            >
              Fetch Next
            </Button>
            <Button
              disabled={!currentClass}
              onClick={getQueueDetals}
              className="review-header-buttons"
            >
              Queue Details
            </Button>
          </>
        )}
        {type === "review" && (
          <>
            <Button
              onClick={fetchNext}
              className="review-header-buttons"
              disabled={!currentClass}
            >
              Fetch Next
            </Button>
            <Button
              onClick={returnToQueue}
              disabled={!currentClass}
              className="review-header-buttons"
            >
              Return Doc to Queue
            </Button>
            <Button
              disabled={!currentClass}
              onClick={getQueueDetals}
              className="review-header-buttons"
            >
              Queue Details
            </Button>
          </>
        )}
        {type === "download" && (
          <>
            <Button
              disabled={!currentClass}
              onClick={getFinalizedList}
              className="review-header-buttons"
            >
              Get Finalized List
            </Button>
            <Button
              disabled={!currentClass}
              onClick={copyClassId}
              className="review-header-buttons"
            >
              <Tooltip title="Copy class id for api call.">
                <CopyOutlined />
              </Tooltip>
            </Button>
          </>
        )}
      </div>
      <div className="custom-tools-header-btns">
        <Typography.Text strong className="review-file-name">
          {title}
        </Typography.Text>
        <div className="custom-tools-header-v-divider" />
        {type === "review" && (
          <>
            <Button
              // onClick={getAllUsers}
              disabled={true}
              className="review-header-buttons"
            >
              History
            </Button>
            <CustomButton
              disabled={!currentClass}
              type="primary"
              className="review-header-buttons"
              onClick={finishReview}
            >
              Finish Review
            </CustomButton>
          </>
        )}
        {(type === "simple_review" || type === "simple_approve") && (
          <CustomButton
            disabled={!currentClass}
            type="primary"
            className="review-header-buttons"
            onClick={finishReviewApi}
          >
            {type === "simple_review" ? "Finish Review" : "Approve"}
          </CustomButton>
        )}
        {type === "approve" && (
          <>
            <Button
              // onClick={getAllUsers}
              disabled={true}
              className="review-header-buttons"
            >
              History
            </Button>
            <CustomButton
              disabled={!currentClass}
              type="primary"
              className="review-header-buttons"
              onClick={finishReview}
            >
              Approve
            </CustomButton>
          </>
        )}
        {type === "download" && (
          <>
            <Dropdown.Button
              disabled={!currentReview}
              placeholder="Download File"
              menu={{
                items,
                onClick: downloadFile,
              }}
              placement="left"
            >
              Download File
            </Dropdown.Button>
          </>
        )}
        {/* {sessionDetails.role === "unstract_admin" && (
          <>
            <Dropdown.Button
              placeholder="Manage"
              menu={{
                items: manageItems,
                onClick: manageClick,
              }}
              placement="left"
            >
              Manage
            </Dropdown.Button>
          </>
        )} */}
      </div>
    </div>
  );
}

ReviewHeader.propTypes = {
  title: PropTypes.string,
  classList: PropTypes.any.isRequired,
  fetchNext: PropTypes.func,
  currentReview: PropTypes.any,
  setCurrentClass: PropTypes.func,
  currentClass: PropTypes.string,
  returnToQueue: PropTypes.func,
  getQueueDetals: PropTypes.func,
  finishReview: PropTypes.func,
  sessionDetails: PropTypes.object,
  type: PropTypes.string,
  getFinalizedList: PropTypes.func,
  setAutoApprove: PropTypes.func,
  autoApprove: PropTypes.bool,
  fetchNextApi: PropTypes.func,
  finishReviewApi: PropTypes.func,
};

export { ReviewHeader };
